/** Packages **/
import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardMedia, CardTitle } from 'material-ui/Card';
import { home } from './../../settings/settings';
// Styles
import './styles.scss';

const DrawerProfile = props => {
  const overlayContentStyles = {
    background: 'rgba(0,0,0,.2)',
    padding: '0'
  };
  const cardTitleStyles = {
    padding: '10px 20px'
  };
  const cardTitleTitleStyles = {
    fontSize: '13px',
    lineHeight: '1rem'
  };
  const cardTitleSubitleStyles = {
    color: 'rgba(255,255,255,1)',
    fontSize: '13px'
  };
  const userName = props.user ? props.user.name : '';
  const staffId = props.user ? props.user.staffId : '';
  let category = props.user ? props.user.currentCategory : {};
  if (category) {
    category = category.categoryName;
  }
  const profileName = (
    <span>
      <span>{userName}</span>
      <span className='StaffId'> ({staffId})</span>
    </span>
  );
  return (
    <Card>
      <CardMedia
        className='Drawer-CardMedia'
        overlay={
          <CardTitle
            title={profileName}
            titleStyle={cardTitleTitleStyles}
            style={cardTitleStyles}
            subtitle={home.displayCategory ? category : ''}
            subtitleStyle={cardTitleSubitleStyles}
          />
        }
        overlayContentStyle={overlayContentStyles}
      >
        <img alt='Background' src={`assets/img/${home.bgAvatar}`} />
      </CardMedia>
    </Card>
  );
};

DrawerProfile.propTypes = {
  user: PropTypes.object.isRequired
};

export default DrawerProfile;
